import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router} from '@angular/router';
import {ConexionesService} from '../../services/conexiones.service'



@Component({
  selector: 'app-noticias',
  templateUrl: './noticias.component.html',
  styleUrls: ['./noticias.component.css']
})
export class NoticiasComponent implements OnInit {
  titulo:any;
  id:any;
  descripcion:any;
  archivo:any;
  fecha2:any;
  noticias:any;
  muestraDetalle = true
  constructor(private db:ConexionesService,
              private route:ActivatedRoute, 
              private router: Router) { }

  ngOnInit(): void {
    window.scroll(0,0);
    this.id = this.route.snapshot.queryParams.id;

    if(this.id==0){
      this.muestraDetalle = false;
    }else{
      this.titulo = this.route.snapshot.queryParams.titulo;
      this.descripcion = this.route.snapshot.queryParams.descripcion;
      this.archivo =  this.route.snapshot.queryParams.archivo;
      this.fecha2 =  this.route.snapshot.queryParams.fecha2;
    }

  
    
    this.db.getNoticiasLimit(9).then((data:any)=>{
      console.log(data)
        this.noticias = data;
    })
    
  }

  irNoticia(item:any){

    this.id = item.id;
    this.titulo = item.titulo;
    this.descripcion = item.descripcion;
    this.archivo =  item.archivo;
    this.fecha2 =  item.fecha2;

    window.scroll(0,300);
    this.muestraDetalle = true;
 }

  onKeydownEvent(){
  // console.log("entra")
    //
    
    this.router.navigate(['/inicio']);
  }

}
